import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";

export const companyFields: FormField[] = [
	{
		name: "name",
		label: "Nazwa",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Nazwa",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "nip",
		label: "NIP",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "NIP",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "regon",
		label: "REGON",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "REGON",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "email",
		label: "Email",
		type: FormRenderTypes.email,
		value: "",
		placeholder: "Email",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "phone",
		label: "Telefon",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Telefon",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "street",
		label: "Ulica",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Ulica",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "buildingNumber",
		label: "Numer budynku",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Numer budynku",
		group: FormRenderGroupTypes.address,
	},
	{
		name: "apartmentNumber",
		label: "Numer mieszkania",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Numer mieszkania",
		group: FormRenderGroupTypes.address,
	},
	{
		name: "postalCode",
		label: "Kod pocztowy",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Kod pocztowy",
		group: FormRenderGroupTypes.address,
	},
	{
		name: "city",
		label: "Miasto",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Miasto",
		group: FormRenderGroupTypes.address,
	},
	{
		name: "country",
		label: "Kraj",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Kraj",
		group: FormRenderGroupTypes.address,
	},
	{
		name: "bankAccounts",
		label: "Konta bankowe",
		type: FormRenderTypes.dynamicList,
		group: FormRenderGroupTypes.values,
		itemFields: [
			{
				name: "accountNumber",
				label: "Numer rachunku",
				type: FormRenderTypes.input,
				sx: { minWidth: 300 },
			},
			{ name: "bankName", label: "Nazwa banku", type: FormRenderTypes.input },
			{ name: "bankBranch", label: "Oddział", type: FormRenderTypes.input },
			{ name: "currency", label: "Waluta", type: FormRenderTypes.input },
			{
				name: "description",
				label: "Opis",
				type: FormRenderTypes.input,
				sx: { minWidth: 500 },
			},
		],
	},
];
